import React, {useCallback, useEffect} from "react";
import {Button, Flex, Space} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleLeft} from "@fortawesome/free-solid-svg-icons";
import {useNavigate, useParams} from "react-router-dom";
import {
    addEdge, applyEdgeChanges,
    Background,
    BackgroundVariant,
    Controls,
    MarkerType,
    ReactFlow,
    useEdgesState,
    useNodesState
} from "@xyflow/react";
import {useAppDispatch, useAppSelector} from "../../../../feature/tools";
import {Status} from "../../../../feature/project/status";
import {fetchFullStory} from "../../../../feature/project/storySlice";
import {Act, Chapter} from "../../../../feature/project/story";

import '@xyflow/react/dist/style.css';
import '../../../../flow-custom.css';
import {makeConnection, removeConnection} from "../../../../feature/project/shotSlice";
import GraphItem from "./GraphItem";
import Title from "antd/es/typography/Title";

const nodeTypes = {
    graphItem: GraphItem,
};

export const GraphsContent = () => {
    const dispatch = useAppDispatch()
    const story = useAppSelector(state => state.stories.storyFull)
    const loadingStatus = useAppSelector(state => state.stories.status)
    const {storyId, projectId} = useParams()

    const navigate = useNavigate()

    const initialNodes: any[] = [];
    const initialEdges: any[] = [];
    const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
    const [edges, setEdges] = useEdgesState(initialEdges);
    const user = useAppSelector(state => state.users.currentUser)

    useEffect(() => {
        if (user && user.role == 'viewer') {
            navigate(`/projects/${projectId}/stories/${storyId}`)
        }
    }, [user]);

    useEffect(() => {
        if (loadingStatus === Status.Idle && projectId && storyId) {
            dispatch(fetchFullStory({projectId: parseInt(projectId), storyId: parseInt(storyId)}))
        }
    }, [projectId, storyId])

    useEffect(() => {
        var rows = 0
        var cols = 0
        var countc = 0
        var actc = 0
        var scenec = 0
        var shotc = 0
        let nodes: any[] = []
        let edges: any[] = []
        actc = 0
        story?.acts?.slice()?.sort((a, b) => a.id! - b.id!)?.map((act: Act) => {
            rows = 0

            actc++
            countc++
            let allShots = act.chapters?.map((chapter) => chapter.scenes?.map((scene) => scene.shots).flat()).flat()
            act.chapters?.slice()?.sort((a, b) => (a.id ?? 0) - (b?.id ?? 0))?.map((chapter: Chapter) => {

                scenec = 0
                chapter.scenes?.slice()?.sort((a, b) => (a.id ?? 0) - (b?.id ?? 0))?.map((scene) => {
                    scenec++
                    shotc = 0
                    scene.shots?.slice()?.sort((a, b) => (a.id ?? 0) - (b?.id ?? 0))?.map((shot, index) => {
                        rows++
                        shotc++
                        nodes.push({
                            id: shot.id?.toString() ?? "",
                            position: {x: cols * 440, y: rows * 150},
                            style: {width: 400, height: 120},
                            type: 'graphItem',
                            data: {
                                label: shot.narration?.text ?? "",
                                chapter: chapter.title,
                                act: actc.toString(),
                                scene: scenec.toString(),
                                shot: shotc.toString() + " [" + shot.id + "]"
                            },
                        })
                        let allindex = allShots?.indexOf(shot) ?? -2
                        let nextShot = (allShots ?? [])[allindex + 1]
                        shot.shots.forEach((shotC) => {
                            edges.push(
                                {
                                    id: shot.id + "-" + shotC.id,
                                    source: shot.id?.toString(),
                                    target: shotC.id?.toString(),
                                    type: 'smoothstep',
                                    targetHandle: nextShot && shotC.id == nextShot.id ? 'vt' : 'ht',
                                    sourceHandle: nextShot && shotC.id == nextShot.id ? 'vs' : 'hs',
                                }
                            )
                        })
                    })
                })
                rows = 0
                cols++
            })
        })
        setNodes(nodes)
        setEdges(edges)
    }, [story]);

    const onConnect = useCallback(
        (params: any) => setEdges((eds) => {

            let edge = edges.find((edge) => edge.source === params.source && edge.target === params.target)

            if (!edge) {
                if (projectId) {
                    dispatch(makeConnection({
                        projectId: parseInt(projectId),
                        source: parseInt(params.source),
                        target: parseInt(params.target)
                    }))
                }

                return addEdge(params, eds)
            }
            return eds
        }),
        [setEdges],
    );

    const onEdgesChange = useCallback((changes: any) => setEdges((eds) => {
        if (projectId && changes[0].type === "remove") {
            dispatch(removeConnection({
                projectId: parseInt(projectId),
                source: parseInt(changes[0].id.split("-")[0]),
                target: parseInt(changes[0].id.split("-")[1])
            }))
        }
        return applyEdgeChanges(changes, eds)
    }), [],);

    return (
        <div style={{paddingBottom: 30, height: "100%"}}>
            <Flex justify={'space-between'}>

                <Space>
                    <Button type={'text'}
                            onClick={() => navigate(-1)}
                            icon={<FontAwesomeIcon icon={faAngleLeft}/>}/>
                    <Title level={4} style={{margin: 0}}>Graph</Title>
                </Space>
            </Flex>
            <ReactFlow nodes={nodes}
                       edges={edges}
                       onNodesChange={onNodesChange}
                       onEdgesChange={onEdgesChange}
                       nodeTypes={nodeTypes}
                       defaultEdgeOptions={{
                           markerEnd: {
                               type: MarkerType.ArrowClosed,
                           },
                           type: 'smoothstep',
                       }}
                       fitView
                       onConnect={onConnect}
            >
                <Controls/>
                <Background variant={BackgroundVariant.Dots} gap={12} size={1}/>
            </ReactFlow>
        </div>
    )
}